import {makeStyles} from "@material-ui/core/styles";

export default makeStyles((theme)=>({
    appBar: {
        borderRadius: 15,
        margin: '30px 0',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
    },
    appBarSearch:{
      borderRadius:4,
      marginBottom:'1rem',
      display:'flex',
      padding:'16px',
    },
    pagination:{
      borderRadius:4,
      marginTop:'1rem',
      padding:'16px',
    },
    gridContainer:{
      [theme.breakpoints.down('xs')]:{
        mainContainer:{
          flexDirection:"column-reverse",
        }
      }
    },
    heading: {
      color: 'rgba(0,183,255, 1)',
    },
    image: {
      marginLeft: '15px',
    },
}));